import { sendRequest } from "../request";
const BASE_URL = '/api/patentApplications';

export function getPatentApplications(user) {
    return sendRequest(`${BASE_URL}/getPatentApplications/${user._id}`);
}